appexport.controller(
    'ExportController', ['$scope', '$sce', '$rootScope', '$state', '$stateParams', '$translate', 'ApiService', ExportController]
);

function ExportController($scope, $sce, $rootScope, $state, $stateParams, $translate, ApiService) {
    var vm = this;
   
    $scope.vm = {};

    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }

    $translate.use($stateParams.langinterface);
    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
    }
    if ($stateParams.type == 'word') {
        ApiService.get('/api/helperAPI/GetExportGenericHtml?z=' + vm.ParamZoneId + '&lang=' + $stateParams.lang + '&objecttype=' + $stateParams.objecttype + '&search=' + $stateParams.search + '&gsearch=' + $stateParams.gsearch + '&qcid=' + $stateParams.qc + '&selectedid=' + $stateParams.selectedid + '&mcd=' + $stateParams.mcd + '&sortkey=' + $stateParams.sortkey + '&reverse=' + $stateParams.reverse).then(
                 function success(data) {
                     vm.results = data;
                 },
                 function error(data) { });

    
    }
    else {
        ApiService.get('/api/helperAPI/GetExportHtml?z=' + vm.ParamZoneId + '&lang=' + $scope.CurrentLang).then(
                 function success(data) {
                     //recharge la page si la position du desc est modifié
                     vm = data;
                     $scope.vm = vm.data;
                 },
                 function error(data) { });

    }

    $scope.getHtml = function (htmlContent) {
        return $sce.trustAsHtml(htmlContent);
    };

    $scope.download = function () {
        HelperService.ExportWord("z=1");
    };

}
